module.exports = __webpack_public_path__ + "img/cash_bundle.adbbc6c3.png";